import { render, staticRenderFns } from "./material-config-form.vue?vue&type=template&id=07c763d6&scoped=true"
import script from "./material-config-form.vue?vue&type=script&setup=true&lang=js"
export * from "./material-config-form.vue?vue&type=script&setup=true&lang=js"
import style0 from "./material-config-form.vue?vue&type=style&index=0&id=07c763d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c763d6",
  null
  
)

export default component.exports